// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3JcDV","label":"SetPasswdForm_label__3Em5g"};